/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import useFilters from '../useFilters'
import { Button, Checkbox, FormField } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { UltyDropdown, UltyInputText } from '@ulty/ulty-ui'

const IsScheduledFilter = () => {
    const [t] = useTranslation()
    const {filters, setFilters} = useFilters()

    const handleIsScheduledChange = (newIsScheduled) => {
        const immediateSelected = newIsScheduled?.includes('immediate');
        const scheduledSelected = newIsScheduled?.includes('scheduled');
        const bothSelected = immediateSelected && scheduledSelected;
        const newFilters = {
            ...filters,
            isScheduled: bothSelected ? undefined : scheduledSelected ? true : immediateSelected ? false : undefined,
        }

        setFilters(newFilters)
    }

    const state = filters.isScheduled === undefined ? '' : filters.isScheduled ? 'scheduled' : 'immediate'

    return (
         <UltyDropdown
            label={t('order.scheduled.isScheduledOrder')}
            multiple
            options={[
                { text: t('order.scheduled.immediate'), key: 'immediate', value: 'immediate' },
                { text: t('order.scheduled.scheduled'), key: 'scheduled', value: 'scheduled' }
            ]}
            placeholder=' '
            value={state}
            onChange={(e, dp) => handleIsScheduledChange(dp.value)}
        />
        /*
      <FormField css={css`
          display: flex;
          flex-direction: column;
      `}>
          <UltyInputText
            readonly
            label={t('order.scheduled.isScheduledOrder')}
          />
          <Button.Group >
              <Button
                color={ (state === 'all' || state === 'immediate') ? 'teal' : '' }
                onClick={() => handleIsScheduledChange(filters.isScheduled === false ? true : undefined)}
              >
                  {t('order.scheduled.immediate','Immédiate')}
              </Button>
              <Button
                toggle
                color={ (state === 'all' || state === 'scheduled') ? 'teal' : '' }
                active={filters.isScheduled === undefined || filters.isScheduled === true}
                onClick={() => handleIsScheduledChange(filters.isScheduled === true ? false : undefined)}
              >
                  {t('order.scheduled.scheduled','Planifiée')}
              </Button>
          </Button.Group>
      </FormField>
      */
    )
}

export { IsScheduledFilter }
